import React from 'react';
import { DefaultValues, SubmitHandler, useForm } from 'react-hook-form';

import InlineInput from '@/components/InlineInput';
import { Button } from '@/components/ui/button';
import { DialogFooter } from '@/components/ui/dialog';
import { Form, FormField } from '@/components/ui/form';
import { zodResolver } from '@hookform/resolvers/zod';

import { fleetFormSchema, FleetFormSchema } from './schema';

interface IProps {
  defaultValues?: DefaultValues<FleetFormSchema>;
  onSubmit: SubmitHandler<FleetFormSchema>;
}

const FleetForm: React.FC<IProps> = ({ defaultValues, onSubmit }) => {
  const form = useForm<FleetFormSchema>({
    defaultValues: defaultValues ?? {
      prefix: '',
    },
    resolver: zodResolver(fleetFormSchema),
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid gap-4 py-4">
          <FormField
            control={form.control}
            name="prefix"
            render={({ field }) => (
              <InlineInput
                title="Prefixo"
                placeholder="Prefixo do veículo"
                disabled={form.formState.isSubmitting}
                {...field}
              />
            )}
          />
        </div>
        <DialogFooter>
          <Button type="submit">Salvar</Button>
        </DialogFooter>
      </form>
    </Form>
  );
};

export default FleetForm;
